import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Avatar from '@components/@core/Avatar';
import Icon from '@components/@core/Icon';

const DepartmentHeader = () => (
    <div className="d-flex mx-0 py-4 desktop-screen">
        <div className="d-flex-3 dsl-m12">Department</div>
        <div className="d-flex-1 dsl-m12 text-center">posts</div>
        <div className="d-flex-2 d-h-center">
            <Icon name="far fa-comment" size={12} />
        </div>
        <div className="d-flex-2 d-h-center">
            <Icon name="far fa-eye" size={12} />
        </div>
        <div className="d-flex-3 dsl-m12">Latest post</div>
    </div>
);

const DepartmentItem = ({ editable, item, onClick, onSelect }) => {
    const { name, data, latest } = item;
    const { blog_posts_abbr, forum__comments_abbr, forum__views_abbr } = data.stats;
    const latestPost = latest[0].name;
    return (
        <div className="d-flex ssm-column cursor-pointer mx-0 py-3" onClick={() => onClick && onClick(item)}>
            <div className="d-flex-3 d-h-start dsl-b16">
                <span className="department-logo">
                    <Icon name={`fas fa-${data?.icon}`} size={16} />
                </span>
                <span className="dsl-b16 ms-2">{name}</span>
            </div>
            <div className="d-flex d-flex-1 jc-center ssm-jc-start mt-0 ssm-y-2">
                <label className="dsl-b14 mobile-screen w-40 mb-0">Posts</label>
                <p className="dsl-b16 mb-0">{blog_posts_abbr}</p>
            </div>
            <div className="d-flex d-flex-2 jc-center ssm-jc-start mt-0 ssm-y-2">
                <Icon name="far fa-comment dsl-b14 mobile-screen w-40 mb-0" size={14} />
                <p className="dsl-b16 mb-0">{forum__comments_abbr}</p>
            </div>
            <div className="d-flex d-flex-2 jc-center ssm-jc-start mt-0 ssm-y-2">
                <Icon name="far fa-eye dsl-b14 mobile-screen w-40 mb-0" size={14} />
                <p className="dsl-b16 mb-0">{forum__views_abbr}</p>
            </div>
            <div className="d-flex d-flex-3 ssm-jc-start mt-0 ssm-y-2">
                <label className="dsl-b14 mobile-screen w-40 mb-0">Latest Posts</label>
                <p className="dsl-b16 mb-0 truncate text-500 mw-150">{latestPost}</p>
            </div>
        </div>
    );
};

const DepartmentDetailedItem = ({ post }) => {
    const { name, data, created_at } = post;
    return (
        <>
            <div className="d-h-between">
                <div className="d-h-start">
                    <Avatar type="logo" url={post.author_avatar} isSponsored={true} />
                    <div className="ml-2">
                        <p className="dsl-m14 mb-2">{`${post.author?.first_name} ${post.author?.last_name}`}</p>
                        <p className="dsl-m14 mb-0">{post.profile?.company}</p>
                    </div>
                </div>
                <p className="dsl-m14 mb-0">{moment(created_at).format('MMM DD, YY')}</p>
            </div>
            <p className="dsl-b18 bold my-3 truncate-two">{name}</p>
            <div className="post-body" dangerouslySetInnerHTML={{ __html: data?.body }} />
        </>
    );
};

export const DepartmentFeed = ({ department, posts }) => {
    if (!department?.name) return null;
    const { name } = department;
    return (
        <div className="bg-white">
            <p className="dsl-b20 bold pt-3 ps-3 mb-0 mt-2">{name}</p>
            {posts.length > 0 ? (
                posts.map((item, index) => (
                    <div className="blog-category-section mb-3" key={`item-${index}`}>
                        <DepartmentDetailedItem post={item} />
                    </div>
                ))
            ) : (
                <p className="dsl-b16 p-3">{`There are no ${name.toLowerCase()} posts.`}</p>
            )}
        </div>
    );
};

const Departments = ({ editable, departments, onDetail, onSelect }) => {
    const handleOpenDetail = (item) => {
        onDetail && onDetail(item);
    };

    return (
        <div className="blog-department-section mt-2">
            <p className="dsl-b20 bold my-2">Departments</p>
            {departments.length > 0 ? (
                <>
                    <DepartmentHeader />
                    {departments.map((department, index) => (
                        <DepartmentItem key={`department-${index}`} editable={editable} item={department} onClick={handleOpenDetail} onSelect={onSelect(index)} />
                    ))}
                </>
            ) : (
                <p className="dsl-b16 p-3">There are no departments.</p>
            )}
        </div>
    );
};

Departments.propTypes = {
    editable: PropTypes.bool,
    departments: PropTypes.array,
    onSelect: PropTypes.func,
};

Departments.defaultProps = {
    editable: false,
    departments: [],
    onSelect: () => {},
};

export default Departments;
